export const isEidValid = (eidValue: string) => BigInt(eidValue) % 97n === 1n;
